import {ErrorPage, getStatusCodeFromError} from '@/shared/ui/components/error-page';

type RootErrorBoundaryProps = {
  readonly error: unknown;
};

export function RootErrorBoundary({error}: RootErrorBoundaryProps) {
  if (error instanceof Error) {
    const statusCode = getStatusCodeFromError(error);
    return <ErrorPage statusCode={statusCode} error={error} />;
  }

  const errorMessage = typeof error === 'string' ? error : 'An unexpected error occurred';
  return <ErrorPage error={new Error(errorMessage)} />;
}

export function RootNotFound() {
  return (
    <ErrorPage
      statusCode={404}
      title="Error 404"
      description="The page you are looking for does not exist."
    />
  );
}
